<div class="row mt-4 mb-3 ms-3">
  <div class="col-3">
    <ng-select [items]="applications" [bindLabel]="'name'" [(ngModel)]="selectedApplication" (ngModelChange)="changeApplication($event)"></ng-select>
  </div>
  <div class="col-3">
    <button class="btn btn-outline-primary" (click)="openCreateModal()">
      <i class="fa fa-lg fa-plus me-1"></i>
      Create role
    </button>
  </div>
</div>
<ngx-datatable
  class="material"
  style="height: calc(100vh - 180px)"
  [rows]="roles"
  [columns]="columns"
  [messages]="{emptyMessage: 'Click to submit to filter', totalMessage: 'Total', selectedMessage: 'Selected'}"
  [columnMode]="ColumnMode.force"
  [headerHeight]="50"
  [footerHeight]="50"
  [scrollbarH]="true"
  [scrollbarV]="true"
  [rowHeight]="50"
>
</ngx-datatable>


<ng-template #nameTmpl let-column="column">{{ column.name }}</ng-template>
<ng-template #descriptionTmpl let-column="column">{{ column.name }}</ng-template>
<ng-template #updateTmpl let-column="column">
<!--  <fa-icon [icon]="faCoffee"></fa-icon>-->
  Update
</ng-template>
<ng-template #deleteTmpl let-column="column">
<!--  <fa-icon [icon]="faRemove"></fa-icon>-->
  Delete role
</ng-template>

<ng-template #nameCellTmpl let-row="row" let-value="value">{{value}}</ng-template>
<ng-template #descriptionCellTmpl let-row="row" let-value="value">{{value}}</ng-template>
<ng-template #updateCellTmpl let-row="row" let-value="value">
<!--  {{value}}-->
  <i class="fa fa-lg fa-user-edit" (click)="openUpdateModal(row)"></i>
</ng-template>
<ng-template #deleteCellTmpl let-row="row" let-value="value">
  <i class="fa fa-lg fa-remove" (click)="deleteRole(row)"></i>
</ng-template>
